import React from 'react';
import { Card, Empty } from 'antd';
import Chart from 'react-apexcharts';

const HistoricalLoadCharts = ({ servidor, height = 300 }) => {
  if (!servidor?.datos?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos históricos disponibles" /></Card>;
  }

  const labels = servidor.datos.map(d => new Date(d.timestamp).getTime());
  const cargaData = servidor.datos.map(d => d.carga);
  const hasMinMax = !!servidor.datos[0]?.max;
  const maxData = servidor.datos.map(d => d.max || d.carga);
  const minData = servidor.datos.map(d => d.min || d.carga);

  const cargaPromedio = (cargaData.reduce((a, b) => a + b, 0) / cargaData.length).toFixed(2);
  const cargaMaxima = Math.max(...cargaData).toFixed(2);
  const cargaMinima = Math.min(...cargaData).toFixed(2);

  const getColor = (avg) => {
    if (avg < 1.0) return { line: '#10b759', status: 'Óptimo' };
    if (avg < 2.0) return { line: '#fd7e14', status: 'Moderado' };
    return { line: '#dc3545', status: 'Alto' };
  };
  const cs = getColor(parseFloat(cargaPromedio));

  const series = [{ name: 'Carga', data: cargaData, type: 'area' }];
  const colors = [cs.line];
  if (hasMinMax) {
    series.push({ name: 'Máximo', data: maxData, type: 'line' }, { name: 'Mínimo', data: minData, type: 'line' });
    colors.push('#dc3545', '#10b759');
  }

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span>{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          <span style={{ fontSize: 12, fontWeight: 'normal' }}>
            <span style={{ color: cs.line, fontWeight: 'bold' }}>{cs.status}</span>
            {' · '}Promedio: {cargaPromedio} · Min: {cargaMinima} · Max: {cargaMaxima}
          </span>
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="line"
        height={height}
        options={{
          chart: { toolbar: { show: false }, zoom: { enabled: true } },
          stroke: { width: [2, 1, 1], curve: 'smooth', dashArray: [0, 5, 5] },
          colors,
          fill: { type: ['gradient', 'solid', 'solid'], gradient: { opacityFrom: 0.3, opacityTo: 0.05 } },
          xaxis: { type: 'datetime', categories: labels, labels: { datetimeFormatter: { day: 'dd/MM', hour: 'dd/MM HH:mm' } } },
          yaxis: { min: 0, title: { text: 'Carga (Load Average)' } },
          grid: { borderColor: '#e5e9f2', strokeDashArray: 3 },
          tooltip: { x: { format: 'dd/MM HH:mm' }, y: { formatter: v => v.toFixed(2) } },
          legend: { position: 'top' },
          dataLabels: { enabled: false },
        }}
        series={series}
      />
    </Card>
  );
};

export default HistoricalLoadCharts;
